<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <route-view></route-view>
    </div>
  </div>
</template>

<script>
  import RouteView from "@/components/layouts/RouteView"
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    name: "UserLayout",
    components: { RouteView},
    mixins: [mixinDevice],
    data () {
      return {
        saas:1
      }
    },
    mounted () {
      document.body.classList.add('userLayout')
    },
    beforeDestroy () {
      document.body.classList.remove('userLayout')
    },
    methods:{

    }
  }
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;

        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      background-size: 100%;
      position: relative;

      background-color: #F4F9FD;
      a {
        text-decoration: none;
      }
    }
  }
</style>